import { render, staticRenderFns } from "./navigation_tabs.vue?vue&type=template&id=3adc2297&"
import script from "./navigation_tabs.vue?vue&type=script&lang=js&"
export * from "./navigation_tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports